import { useSyncExternalStore } from "react";

/**
 * The phone layout's breakpoint (доски M*, 390×844): at or below it the rail
 * becomes the bottom tabs and each screen draws its phone variant. One number,
 * so the shell and every screen agree on which side of it they are.
 */
export const PHONE_MAX_WIDTH = 768;

const QUERY = `(max-width: ${PHONE_MAX_WIDTH}px)`;

function subscribe(onChange: () => void): () => void {
  if (typeof window === "undefined" || !window.matchMedia) return () => {};
  const mq = window.matchMedia(QUERY);
  mq.addEventListener("change", onChange);
  return () => mq.removeEventListener("change", onChange);
}

function snapshot(): boolean {
  return typeof window !== "undefined" && !!window.matchMedia && window.matchMedia(QUERY).matches;
}

/** True on a phone-width viewport; follows a rotation or a resized window. */
export function useIsPhone(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => false);
}
